import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useParams, useHistory } from 'react-router'

import { useRecoilValue } from 'recoil'

import {
  PageHeader,
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_SIZE_LG
} from 'mailup-web-components'
import { notifyParent } from 'Helpers/notifyParent'
import { pageState } from 'Pages/EmailMessagePreview/recoil/state/page'
import { BASIC_VIEW } from 'Pages/EmailMessagePreview/const'

import useMessageSendAction from 'Hooks/useMessageSendAction'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const { id } = useParams()
  const [redirectUrl] = useRedirectorUrl()

  const { pageTitle, view } = useRecoilValue(pageState)

  const handleSend = useMessageSendAction(id)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailPreview', redirectUrl])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Saved' }),
      'data-mu-test': 'breadcrumb-item__saved',
      className: 'test-breadcrumb-item__saved',
      url: '#',
      onClick: () => history.push('/messages/email/saved')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Previews' }),
      'data-mu-test': 'breadcrumb-item__previews',
      className: 'test-breadcrumb-item__previews'
    }
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Overview' }),
      'data-mu-test': 'topmenu-item__overview',
      className: 'test-topmenu-item__overview',
      onClick: () =>
        history.push(
          `/messages/email/${id}/overview?source=emailPreviews&op=mod`
        )
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.EmailCheckup' }),
      'data-mu-test': 'topmenu-item__emailcheckup',
      className: 'test-topmenu-item__emailcheckup',
      onClick: () => history.push(`/messages/email/${id}/checkup/summary`)
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Previews' }),
      'data-mu-test': 'topmenu-item__previews',
      className: 'test-topmenu-item__previews',
      isActive: true,
      onClick: () => null
    }
  ]

  const ControlsComponent = () =>
    view > BASIC_VIEW ? (
      <Button
        kind={BUTTON_VARIANT_PRIMARY}
        size={BUTTON_SIZE_LG}
        onClick={handleSend}
        data-mu-test='cta-send'
      >
        {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
      </Button>
    ) : null

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      title={pageTitle}
      ControlsComponent={ControlsComponent}
      loading={!pageTitle}
    />
  )
}

export default Header
